import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Gear, ArrowLeft, ChartPieSlice } from '@phosphor-icons/react'

import NavbarTabs from '../NavbarTabs/NavbarTabs'

import InspectionsTopNavbarItem from './components/InspectionsTopNavbarItem'

const InternalInspectionsNavbar = ({
  onScheduleInspection = () => {},
  onCreateWorkOrder = () => {},
  onToggleAnalytics = () => {},
  showAnalytics = true,
  location,
}) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  const navigate = useNavigate()
  const { pathname } = location
  const prefix = '/dashboard/building-dashboard/internal-inspections'
  let currentView = null

  const navbarTabs = [
    {
      name: t('internal-inspections:navbar.recurring'),
      path: '/dashboard/building-dashboard/internal-inspections/setup/recurring',
    },
    {
      name: t('internal-inspections:navbar.templates'),
      path: '/dashboard/building-dashboard/internal-inspections/setup/templates',
    },
  ]

  if (pathname.includes(`${prefix}/dashboard`)) {
    currentView = (
      <InspectionsTopNavbarItem
        header={t('internal-inspections:navbar.inspections')}
        leftContent={
          <button onClick={onToggleAnalytics} className="button button-lightgray">
            <ChartPieSlice />
            {showAnalytics
              ? t('internal-inspections:navbar.hideAnalytics')
              : t('internal-inspections:navbar.showAnalytics')}
          </button>
        }
        rightContent={
          <React.Fragment>
            <button onClick={onScheduleInspection} className="button button-black">
              {t('internal-inspections:navbar.scheduleInspection')}
            </button>
            <hr />
            <button
              onClick={() =>
                navigate('/dashboard/building-dashboard/internal-inspections/setup/recurring')
              }
              className="button button-lightgray"
            >
              <Gear />
              {t('internal-inspections:navbar.inspectionsSetup')}
            </button>
          </React.Fragment>
        }
      />
    )
  } else if (pathname.includes(`${prefix}/setup/recurring`)) {
    currentView = (
      <InspectionsTopNavbarItem
        leftContent={
          <React.Fragment>
            <button
              onClick={() =>
                navigate('/dashboard/building-dashboard/internal-inspections/dashboard')
              }
              className="button button-lightgray"
            >
              <ArrowLeft />
              {t('common:actions.back')}
            </button>
            <div className="header">{t('internal-inspections:navbar.inspectionsSetup')}</div>
          </React.Fragment>
        }
        rightContent={
          <button onClick={onScheduleInspection} className="button button-black">
            {t('internal-inspections:navbar.scheduleInspection')}
          </button>
        }
      >
        <NavbarTabs routes={navbarTabs} />
      </InspectionsTopNavbarItem>
    )
  } else if (pathname.includes(`${prefix}/setup/templates`)) {
    currentView = (
      <InspectionsTopNavbarItem
        leftContent={
          <React.Fragment>
            <button
              onClick={() =>
                navigate('/dashboard/building-dashboard/internal-inspections/dashboard')
              }
              className="button button-lightgray"
            >
              <ArrowLeft />
              {t('common:actions.back')}
            </button>
            <div className="header">{t('internal-inspections:navbar.inspectionsSetup')}</div>
          </React.Fragment>
        }
        rightContent={
          <button
            onClick={() =>
              navigate('/dashboard/building-dashboard/internal-inspections/template/create')
            }
            className="button button-black"
          >
            {t('internal-inspections:navbar.createTemplate')}
          </button>
        }
      >
        <NavbarTabs routes={navbarTabs} />
      </InspectionsTopNavbarItem>
    )
  } else if (pathname.includes(`${prefix}/details`)) {
    currentView = (
      <InspectionsTopNavbarItem
        leftContent={
          <button
            onClick={() => navigate('/dashboard/building-dashboard/internal-inspections/dashboard')}
            className="button button-lightgray"
          >
            <ArrowLeft />
            {t('common:actions.back')}
          </button>
        }
        rightContent={
          <button onClick={onCreateWorkOrder} className="button button-black">
            {t('internal-inspections:navbar.createWorkOrder')}
          </button>
        }
      />
    )
  }

  return currentView
}

InternalInspectionsNavbar.propTypes = {
  location: PropTypes.object,
  onScheduleInspection: PropTypes.func,
  onCreateWorkOrder: PropTypes.func,
  onToggleAnalytics: PropTypes.func,
  showAnalytics: PropTypes.bool,
}

export default InternalInspectionsNavbar
